import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import Hidden from "@insite/mobius/Hidden/Hidden";
import Icon from "@insite/mobius/Icon/Icon";
import LazyImage from "@insite/mobius/LazyImage";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomComma from "@tSurya/Icons/CustomComma";
import NextArrow from "@tSurya/Icons/NextArrow";
import PreviousArrow from "@tSurya/Icons/PreviousArrow";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import useEmblaCarousel from "embla-carousel-react";
import React, { createRef, FC, useEffect } from "react";
import { useState } from "react";
import { useCallback } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface Memberlist {
    fields: {
        img: string;
        description: string;
        author: string;
        designation: string;
        maintitle: string;
        lowerText: string;
        path2: LinkFieldValue;
    };
}

const enum fields {
    divisions = "divisions",
    header = "header",
    description = "description",
    buttonLabel = "buttonLabel",
    buttonLink = "buttonLink",
    slideIndicator = "slideIndicator",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.divisions]: Memberlist[];
        [fields.header]: string;
        [fields.description]: string;
        [fields.buttonLabel]: string;
        [fields.buttonLink]: LinkFieldValue;
        [fields.slideIndicator]: boolean;
        lowerText: LinkFieldValue;
        path2: LinkFieldValue;
    };
    maxNumberOfColumns: number;
    maintitle: string;
    lowerText: LinkFieldValue;
    path2: LinkFieldValue;
}
type Props = OwnProps & ThemeProps<BaseTheme> & HasShellContext;

export interface Imgstyle {
    ContentImg?: InjectableCss;
    container?: InjectableCss;
    twrapper?: InjectableCss;
    parentDiv?: GridContainerProps;
    prevArrowWrapper?: InjectableCss;
    buttonPREV?: InjectableCss;
    ImageAndSpecialwrapper?: InjectableCss;
    main?: InjectableCss;
    nextArrowWrapper?: InjectableCss;
    buttonNEXT?: InjectableCss;
    button?: LinkPresentationProps;
    Maintitle?: InjectableCss;
    parentContainer?: InjectableCss;
    wrapper?: InjectableCss;
    subtittle?: InjectableCss;
    Box?: InjectableCss;
    h2wrapper?: InjectableCss;
    headerDiv?: InjectableCss;
    header?: InjectableCss;
    description?: InjectableCss;
    ViewMoreBtn?: InjectableCss;
    dotButton?: InjectableCss;
    indicator?: InjectableCss;
    comma?: InjectableCss;
    descriptionContainer?: InjectableCss;
    author?: InjectableCss;
    designation?: InjectableCss;
    wrapperContainer?: InjectableCss;
    mainWrapper?: InjectableCss;
}

export const imgstyle: Imgstyle = {
    Box: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    descriptionContainer: {
        css: css`
            /* margin-left: 81px; */
        `,
    },
    ContentImg: {
        css: css`
            width: 100%;

            img {
                object-fit: contain;
                width: 100%;
                /* max-width: 420px; */
                /* min-width: 420px; */
                aspect-ratio: 1/1;
            }
        `,
    },

    buttonPREV: {
        css: css`
            padding: 0;
            span {
                background-color: ${getColor("primary.contrast")};
                svg {
                    color: #2c2420;
                    background-color: ${getColor("primary.contrast")};
                }
            }
        `,
    },
    buttonNEXT: {
        css: css`
            padding: 0;
            span {
                background-color: ${getColor("primary.contrast")};
                svg {
                    color: #2c2420;
                    background-color: ${getColor("primary.contrast")};
                }
            }
        `,
    },
    header: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 600;
            font-size: 28px;
            line-height: 38px;
            text-align: center;
            text-transform: uppercase;
            color: ${getColor("text.main")};
            margin-bottom: 32px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 16px;
                    `,
                    css`
                        margin-bottom: 16px;
                    `,
                    css`
                        margin-bottom: 16px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    subtittle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: 23px;
            color: ${COLORS.text.main};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css``,
                    css``,
                    css``,
                    css``,
                ])};
        `,
    },
    prevArrowWrapper: {
        css: css`
            position: absolute;
            z-index: 1;
            top: 60%;
            left: -130px;
            > button[class^="ButtonWrapper"] {
                background-color: ${getColor("common.backgroundContrast")};
                border: 1px solid ${getColor("common.backgroundContrast")};
                outline: none;
                svg {
                    background-color: ${getColor("common.backgroundContrast")};
                }
            }
        `,
    },
    nextArrowWrapper: {
        css: css`
            position: absolute;
            z-index: 1;
            top: 60%;
            right: -130px;
            > button[class^="ButtonWrapper"] {
                background-color: ${getColor("common.backgroundContrast")};
                border: 1px solid ${getColor("common.backgroundContrast")};
                outline: none;
                svg {
                    background-color: ${getColor("common.backgroundContrast")};
                }
            }
        `,
    },
    twrapper: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: italic;
            font-weight: 400;
            font-size: 16px;
            line-height: 34px;
            color: ${getColor("text.accent")};
        `,
    },
    parentContainer: {
        css: css`
            position: relative;
            padding: 0;
            width: 100%;
            max-width: 100%;
            /* max-width: 392px; */
            flex: 0 0 auto;
            /* margin-right: 30px;
            margin-left: 20px; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100% !important;
                        margin-right: 20px;
                        margin-left: 10px;
                    `,
                    css`
                        max-width: 100% !important;
                        margin-right: 20px;
                        margin-left: 10px;
                    `,
                    css`
                        max-width: 100% !important;
                        margin-right: 20px;
                        margin-left: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    parentDiv: {
        css: css`
            display: flex;
            /* grid-column-gap: 50px; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        gap: 0px;
                    `,
                    css`
                        gap: 0px;
                    `,

                    css`
                        /* gap: 25px; */
                    `,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        css: css`
            overflow: hidden;
            width: 100%;
            /* width:calc(100% - 160px); */
            /* max-width: 1280px !important; */
        `,
    },
    wrapper: {
        css: css`
            position: relative;
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    css`
                        padding: 0;
                        margin-left: 0;
                        margin-right: 0;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    ImageAndSpecialwrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            flex: 0 0 45%;
            max-width: 420px;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        align-self: center;
                    `,
                    css`
                        align-self: center;
                    `,
                    css`
                        align-self: center;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    main: {
        css: css`
            position: relative;
            width: 100%;
            max-width: 1064px !important;
            margin: 0 auto;
        `,
    },
    h2wrapper: {
        css: css`
            border: 2px solid black;
        `,
    },
    headerDiv: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            justify-content: center;
            align-items: center;
        `,
    },
    description: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.larger};
            line-height: ${TYPOGRAPHY.lineHeight.lmedium};
            text-align: center;
            color: ${getColor("text.accent")};
            margin-bottom: 27px;
        `,
    },
    ViewMoreBtn: {
        css: css`
            padding: 10px 34px;
            background: ${getColor("primary")};
            border-radius: 0px;
            border: 2px solid ${getColor("primary")};
            margin-bottom: 27px;
            :hover span[class^="TypographyStyle"] {
                color: ${getColor("primary.contrast")};
            }
            span[class^="TypographyStyle"] {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: 24px;
                color: ${getColor("primary.contrast")};
            }
        `,
    },
    dotButton: {
        css: css`
            border-radius: 50%;
            /* background: #d9d9d9; */
            opacity: 0.4;
            /* border: 1px solid #d9d9d9; */
            margin: 16px;
            min-height: 10px !important;
            padding: 3px !important;
            &:hover,
            &:active {
                background: ${getColor("primary")} !important;
                opacity: 1 !important;
            }
            &:focus {
                outline: none;
            }
        `,
    },
    indicator: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 32px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 16px;
                    `,
                    css`
                        margin-top: 16px;
                    `,
                    css`
                        margin-top: 16px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    comma: {
        css: css`
            margin-bottom: 35px;
            margin-top: 38px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 10px;
                        margin-top: 15px;
                    `,
                    css`
                        margin-bottom: 10px;
                        margin-top: 15px;
                    `,
                    css`
                        margin-bottom: 10px;
                        margin-top: 15px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    author: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: ${getColor("text.main")};
            margin-top: 35px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 10px;
                    `,
                    css`
                        margin-top: 10px;
                    `,
                    css`
                        margin-top: 10px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    designation: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: ${getColor("text.main")};
        `,
    },
    wrapperContainer: {
        css: css`
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            gap: 81px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        gap: 0px;
                        height: auto;
                    `,
                    css`
                        flex-direction: column;
                        gap: 0px;
                        height: auto;
                    `,
                    css`
                        flex-direction: column;
                        gap: 0px;
                        height: auto;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    mainWrapper: {
        css: css`
            opacity: 1;
            position: relative;
            margin: 0 auto;
            padding-top: 60px;
            padding-bottom: 60px;
            background-color: ${getColor("common.backgroundContrast")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 20px;
                    `,
                    css`
                        padding: 20px;
                    `,
                    css`
                        padding: 20px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
};

const styles = imgstyle;

export const SurCareersSlides: FC<Props> = ({
    fields,
    maxNumberOfColumns = fields.divisions.length,
    theme,
    shellContext,
}) => {
    const { url } = useGetLink(fields.buttonLink);
    const afterCarousel = createRef<HTMLSpanElement>();

    const [emblaRef, embla] = useEmblaCarousel();

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [windowResizeTime, setWindowResizeTime] = useState(0);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const setCanScroll = () => {
        if (shellContext.isInShell) {
            return;
        }
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    const getSlidesToScroll = useCallback(() => {
        // const maxNumberOfColumns = fields.divisions.length || 6;

        if (typeof window === "undefined") {
            return maxNumberOfColumns;
        }

        let localSlidesToScroll: number;
        if (window.innerWidth < theme.breakpoints.values[1]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[2]) {
            localSlidesToScroll = 1;
        } else if (window.innerWidth < theme.breakpoints.values[3]) {
            localSlidesToScroll = 1;
        } else {
            localSlidesToScroll = 1;
        }
        return Math.min(localSlidesToScroll, maxNumberOfColumns);
    }, [maxNumberOfColumns]);

    const [slidesToScroll, setSlidesToScroll] = useState(getSlidesToScroll());

    const getDraggable = () => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < theme.breakpoints.values[1];
    };

    const [draggable, setDraggable] = useState(getDraggable());

    useEffect(() => {
        const newSlidesToScroll = getSlidesToScroll();
        setSlidesToScroll(newSlidesToScroll);

        const newDraggable = getDraggable();
        setDraggable(newDraggable);
    }, [maxNumberOfColumns, windowResizeTime]);

    // useEffect(() => {
    //     if (!embla) {
    //         return;
    //     }
    //     embla.on("select", () => {
    //         setSelectedIndex(embla.selectedScrollSnap());
    //     });

    //     embla.on("init", setCanScroll);
    //     embla.on("select", setCanScroll);

    //     const onWindowResize = () => {
    //         setWindowResizeTime(Date.now());
    //     };

    //     window.addEventListener("resize", onWindowResize);
    //     onWindowResize();

    //     return () => {
    //         window.removeEventListener("resize", onWindowResize);
    //     };
    // }, [embla]);

    useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("select", () => {
            setSelectedIndex(embla.selectedScrollSnap());
        });
    }, [embla]);

    const onWindowResize = () => {
        setWindowResizeTime(Date.now());
    };
    React.useEffect(() => {
        onWindowResize();
    }, []);

    React.useEffect(() => {
        if (!embla || !fields.divisions || fields.divisions.length === 0) {
            return;
        }

        embla.reInit({
            align: "start",
            slidesToScroll,
            //draggable,
            loop: fields.divisions.length > slidesToScroll,
            // loop: fields.divisions.length > slidesToScroll,
        });
        setCanScroll();
    }, [embla, slidesToScroll, draggable, fields.divisions]);

    if (!fields.divisions || fields.divisions.length === 0) {
        return null;
    }
    return (
        <>
            <StyledWrapper {...styles.mainWrapper}>
                <StyledWrapper {...styles.main}>
                    <StyledWrapper {...styles.header}> {fields.header} </StyledWrapper>
                    <Hidden below="lg">
                        <StyledWrapper>
                            {fields.divisions.length > 1 && (
                                <StyledWrapper
                                    {...styles.prevArrowWrapper}
                                    style={{
                                        display: `${slidesToScroll >= fields.divisions.length ? "none" : "block"}`,
                                    }}
                                >
                                    <Button
                                        {...styles.buttonPREV}
                                        onClick={() => {
                                            embla && embla.scrollPrev();
                                        }}
                                        disabled={!canScrollPrev}
                                        role="button"
                                        aria-label="Previous Click"
                                    >
                                        <ButtonIcon src={PreviousArrow} />
                                    </Button>
                                </StyledWrapper>
                            )}
                            <StyledWrapper
                                {...styles.nextArrowWrapper}
                                style={{
                                    display: `${slidesToScroll >= fields.divisions.length ? "none" : "block"}`,
                                }}
                            >
                                <Button
                                    {...styles.buttonNEXT}
                                    onClick={() => {
                                        embla && embla.scrollNext();
                                    }}
                                    disabled={!canScrollNext}
                                    role="button"
                                    aria-label="Next Click"
                                >
                                    <ButtonIcon src={NextArrow} />
                                </Button>
                            </StyledWrapper>
                        </StyledWrapper>
                    </Hidden>
                    <StyledWrapper {...styles.wrapper}>
                        <StyledWrapper {...styles.container} ref={emblaRef}>
                            <StyledWrapper {...styles.parentDiv}>
                                {fields.divisions?.map((division, index) => {
                                    return (
                                        <>
                                            <StyledWrapper
                                                {...styles.parentContainer}
                                                style={{ width: `calc(100% / ${slidesToScroll})` }}
                                                key={index}
                                            >
                                                <StyledWrapper {...styles.wrapperContainer}>
                                                    <StyledWrapper {...styles.ImageAndSpecialwrapper}>
                                                        <LazyImage
                                                            {...styles.ContentImg}
                                                            src={division.fields.img}
                                                            altText="careers Image"
                                                        />
                                                    </StyledWrapper>
                                                    <StyledWrapper {...styles.descriptionContainer}>
                                                        <Icon src={CustomComma} {...styles.comma}></Icon>
                                                        {division.fields.description && (
                                                            <StyledWrapper {...styles.twrapper}>
                                                                {division.fields.description}
                                                            </StyledWrapper>
                                                        )}

                                                        {division.fields.author && (
                                                            <StyledWrapper {...styles.author}>
                                                                {division.fields.author}
                                                            </StyledWrapper>
                                                        )}
                                                        {division.fields.designation && (
                                                            <StyledWrapper {...styles.designation}>
                                                                {division.fields.designation}
                                                            </StyledWrapper>
                                                        )}
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </>
                                    );
                                })}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.indicator}>
                    {fields.slideIndicator && (
                        <StyledWrapper className="slide-indicator">
                            {fields.divisions.map((_, i) => {
                                const dotColorStyles =
                                    i === selectedIndex
                                        ? `
                                        background: ${getColor("text.main")} !important;
                                        opacity:1 !important;
                                    
                                        &:hover { background: ${getColor("text.main")} !important; }
                                        &:active {
                                            background: ${getColor("text.main")} !important;
                                        }
                                    `
                                        : "";
                                const dotButtonStyles = {
                                    css: css`
                                        ${styles.dotButton?.css || ""}
                                        ${dotColorStyles}
                                        .active {
                                            background-color: #f00 !important;
                                        }
                                    `,
                                };

                                return (
                                    <Button
                                        className="slide-dot-button"
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={i}
                                        {...dotButtonStyles}
                                        onClick={() => embla && embla.scrollTo(i)}
                                        role="button"
                                        aria-label="dot click"
                                    />
                                );
                            })}
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const settingsTab = {
    displayName: "Settings",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: withIsInShell(withTheme(SurCareersSlides)),
    definition: {
        group: "Basic",
        displayName: "SurCareersSlides",
        fieldDefinitions: [
            {
                name: fields.slideIndicator,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: settingsTab,
            },
            {
                name: fields.header,
                displayName: "Header",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "text placeholder",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.divisions,
                editorTemplate: "ListField",
                getDisplay: ({ fields: { title } }) => "title",
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "img",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                        displayName: "Image",
                    },
                    {
                        name: "description",
                        editorTemplate: "TextField",
                        displayName: "Decription",
                        defaultValue: "",
                    },
                    {
                        name: "author",
                        editorTemplate: "TextField",
                        displayName: "Author",
                        defaultValue: "",
                    },
                    {
                        name: "designation",
                        editorTemplate: "TextField",
                        displayName: "Designation",
                        defaultValue: "",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
